module.exports = __webpack_public_path__ + "static/media/favicon.b0ea4efc.ico";